var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCdek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 796,
    height: 256,
    viewBox: "0 0 796 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.3 193.18H87.6638C33.6306 193.18 72.8857 61.8064 118.375 61.8064H173.101C181.876 61.8064 197.347 63.657 204.967 38.8094L216.743 0.216675H141.697C101.057 0.216675 69.4217 16.6054 46.5617 44.0961C7.07579 91.1473 -6.31705 164.632 3.15033 199.789C12.1559 232.301 36.6325 253.713 74.9636 254.241L104.751 254.505H141.466L150.472 223.579C157.168 201.639 142.159 193.18 122.3 193.18ZM543.945 138.727L555.258 96.6986H434.493C414.404 96.6986 405.398 103.043 401.935 116.259L390.62 158.288H511.387C531.476 158.288 540.481 151.944 543.945 138.727ZM372.609 212.741L361.294 254.77H482.061C501.919 254.77 511.156 248.426 514.619 235.209L525.934 193.18H405.167C385.309 193.18 376.303 199.524 372.609 212.741ZM572.116 42.5101L583.433 0.481005H462.664C442.575 0.481005 433.569 6.825 430.106 20.0417L418.791 62.0708H539.558C559.419 62.0708 568.421 55.7268 572.116 42.5101ZM389.696 50.9688C384.616 11.8474 366.374 0.481005 322.039 0.481005H241.22L194.114 158.288H223.902C241.682 158.288 250.688 158.553 260.155 129.476L279.782 61.8064H309.801C335.432 61.8064 329.659 98.549 316.728 134.234C305.183 165.689 285.093 193.445 260.847 193.445H210.74C190.65 193.445 181.414 199.789 177.719 213.005L165.25 255.034H201.965L237.987 254.77C269.853 254.505 295.946 251.862 326.426 220.407C358.754 186.836 396.162 100.663 389.696 50.9688ZM795.641 0.216675H725.675L659.864 80.3097C652.241 89.5612 644.391 98.8128 636.769 109.651H636.076L668.866 0.216675H611.835L534.939 254.77H591.975L616.449 174.677L641.849 150.094L661.941 222.521C668.173 244.989 674.643 254.77 688.498 254.77H732.14L687.34 112.559L795.641 0.216675Z",
    fill: "url(#paint0_linear_128_2628)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_128_2628",
    x1: -29.3037,
    y1: 0.216663,
    x2: 814.506,
    y2: 145.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5EA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB9B45"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdek);
export default __webpack_public_path__ + "static/media/cdek.3063202e01a6be3bea2603b8bfb06de1.svg";
export { ForwardRef as ReactComponent };